import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServicePost = {
    path: "/template/service",
    method: ERouteHttpVerb.POST
};
export { routeLocationServicePost };
